(() => {
  const GRID_SELECTOR = '#product-grid';
  const PAGINATION_SELECTOR = '.pagination-wrapper';

  function getNextUrl(pagination) {
    const nextLink = pagination?.querySelector('a.pagination__item--prev');
    return nextLink?.href || null;
  }

  function prepareItem(item) {
    item.classList.remove('scroll-trigger', 'animate--slide-in');
    item.style.removeProperty('--animation-order');
    item.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
      element.style.removeProperty('--animation-order');
    });
    return item;
  }

  function setupInfiniteScroll() {
    const container = document.querySelector('#ProductGridContainer');
    const grid = container?.querySelector(GRID_SELECTOR);
    const pagination = container?.querySelector(PAGINATION_SELECTOR);

    if (!container || !grid || !pagination || container.dataset.infiniteScrollReady === 'true') return;

    let nextUrl = getNextUrl(pagination);
    if (!nextUrl) return;

    container.dataset.infiniteScrollReady = 'true';
    pagination.hidden = true;

    const sentinel = document.createElement('div');
    sentinel.className = 'collection-infinite-scroll-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.minHeight = '1px';
    pagination.insertAdjacentElement('afterend', sentinel);

    let loading = false;

    const observer = new IntersectionObserver(async (entries) => {
      if (!entries[0]?.isIntersecting || loading || !nextUrl) return;

      loading = true;

      try {
        const response = await fetch(nextUrl, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error('Failed to load more products');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.querySelector(GRID_SELECTOR);
        const nextPagination = doc.querySelector(PAGINATION_SELECTOR);

        if (!nextGrid) {
          nextUrl = null;
          observer.disconnect();
          sentinel.remove();
          return;
        }

        const fragment = document.createDocumentFragment();
        Array.from(nextGrid.children).forEach((item) => {
          fragment.appendChild(prepareItem(document.importNode(item, true)));
        });
        grid.appendChild(fragment);

        nextUrl = getNextUrl(nextPagination);

        if (!nextUrl) {
          observer.disconnect();
          sentinel.remove();
        }
      } catch (error) {
        observer.disconnect();
        sentinel.remove();
        pagination.hidden = false;
        container.dataset.infiniteScrollReady = 'false';
      } finally {
        loading = false;
      }
    }, { rootMargin: '900px 0px' });

    observer.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupInfiniteScroll, { once: true });
  } else {
    setupInfiniteScroll();
  }

  document.addEventListener('shopify:section:load', setupInfiniteScroll);
})();